import React, { useEffect, useRef, useState } from "react";
import {
  ADMIN_ICON,
  PROFILE_IMG,
} from "../../../utills/image-constant";
import TableHeading from "../../components/common/TableHeading";
import Inputwithlable from "../../components/common/inputwithlable";
import { toastEmitter } from "../../../utills/utilities";
import { addAllAdmin, getAdminById, updateAdminProfile, uploadFile } from "../../../services/api-services";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedUserReducer } from "../../hooks/redux/slice/logged-user";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";

const AdminProfile = () => {
  const [userProfile, setUserProfile] = useState();
  const { value } = useSelector((state) => state?.loggedUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState(value?.email)
  const [employeeData, setEmployeeData] = useState({
    id: "",
    name: "",
    imageUrl: "",
  });

  const getAdminDetails = async () => {
    try {
      const response = await getAdminById(value?.id);
      if (response?.data?.responseCode == 200) {
        let value = response?.data?.responseBody
        setEmployeeData({
          ...employeeData,
          id: value?.id,
          name: value?.name,
          imageUrl: value?.imageUrl,
        })
        dispatch(setLoggedUserReducer(response?.data?.responseBody));
      } else {

        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  }

  useEffect(() => {
    getAdminDetails()
  }, [])

  const imgRef = useRef();
  const handleImgClick = (e) => {
    imgRef.current.click();
  };

  const OnFileUpload = (e) => {
    let file = e?.target?.files?.[0];
    setUserProfile(URL?.createObjectURL(file));
    if (file?.size > 5242880) {
      toastEmitter(
        "error",
        "Failed to upload an image. The image maximum size is 5MB."
      );
      return false;
    }
    if (
      file?.type === "image/png" ||
      file?.type === "image/jpeg" ||
      file?.type === "image/jpg"
    ) {
      uploadProfile(file);
    } else {
      return toastEmitter(
        "error",
        "The type of the uploaded image should be in png, jpeg, jpg format."
      );
    }
  };

  const uploadProfile = async (file) => {
    const formdata = new FormData();
    formdata.append("file", file);
    try {
      const response = await uploadFile(formdata);
      if (response?.data?.responseCode == 200) {
        setUserProfile(response?.data?.responseBody)
        setEmployeeData({
          ...employeeData, imageUrl: response?.data?.responseBody
        })
        toastEmitter("success", response?.data?.message);
      } else {
        // setButtonStatus(false)
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setEmployeeData({ ...employeeData, [name]: value })
  }

  const handleChangeProfile = async () => {
    try {
      const response = await updateAdminProfile(employeeData);
      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
      }
      if (response.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        getAdminDetails(value?.id)
        navigate(ROUTES?.DASHBOARD)
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  }

  return (
    <>
      <div>
        <TableHeading firstData="Profile" />
      </div>
      <div className="admin_profile m-3 p-3">
        <div className="d-flex justify-content-center align-items-center position-relative">
          <div className="profile-img-div">
            <img
              src={employeeData?.imageUrl ? employeeData?.imageUrl : userProfile ? userProfile : PROFILE_IMG}
              className="profileimg  mb-3"
              alt="PROFILE_IMG"
            />
          </div>
          <div className="">
            <img
              src={ADMIN_ICON}
              className="mb-3 profile-icon"
              type="button"
              alt="WHITEBGDOWNARROW_IMG"
              onClick={handleImgClick}
            />
            <input
              className="form-control"
              type="file"
              hidden
              ref={imgRef}
              id="imgFileUpload"
              accept="image/*"
              onChange={OnFileUpload}
            />
          </div>

        </div>
        <div className="row ">
          <div className="col-md-6">
            <Inputwithlable
              placeHolder="Enter Name"
              name="name"
              type="text"
              labelName="Name"
              lableclassName="addInput-label"
              className="form-control addInputText-lable"
              value={employeeData.name}
              handleChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <Inputwithlable
              placeHolder="Enter Email"
              name="email"
              type="text"
              labelName="Email"
              lableclassName="addInput-label"
              className="form-control addInputText-lable"
              value={email}
              disable={true}
              handleChange={handleChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <button className="savebtn mt-4" onClick={handleChangeProfile}>Save Changes</button>
        </div>
      </div>

    </>
  );
};

export default AdminProfile;
